"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarMenuButtonArrow = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const ToolbarMenuButtonArrow = (0, _styled.default)("div")`
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    line-height: 0;
    font-size: 0;
    user-select: none;

    padding-right: 2px;
`;
exports.ToolbarMenuButtonArrow = ToolbarMenuButtonArrow;
//# sourceMappingURL=ToolbarMenuButtonArrow.js.map